import AddCategoryModule from '@/modules/category/add-category';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  id: z.coerce.string().optional(),
});

export const Route = createFileRoute('/dashboard/category/add-category/')({
  validateSearch: searchSchema,
  component: AddCategoryPage,
});

function AddCategoryPage() {
  return <AddCategoryModule />;
}
